import React, { useState } from 'react'
import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  Tooltip
} from '@material-ui/core'
import CheckIcon from '@material-ui/icons/Check'
import ClearIcon from '@material-ui/icons/Clear'
import RefreshIcon from '@material-ui/icons/Refresh'
import service from './JiraResourcesService'
import { useJiraBoardSwimlane } from './useJiraBoardSwimlane'

export function JiraBoardSwimlane({ projectKey }: { projectKey: string }) {
  const [reloadCounter, setReloadCounter] = useState(0)
  const swimlane = useJiraBoardSwimlane(projectKey, reloadCounter)
  const [updateClicked, setUpdateClicked] = useState(false)
  const [updating, setUpdating] = useState(false)

  function onUpdate(): void {
    setUpdateClicked(true)
    setUpdating(true)
    service
      .putBoardSwimlane(projectKey)
      .catch(() => {})
      .finally(() => {
        setUpdating(false)
        setReloadCounter(reloadCounter + 1)
      })
  }

  const status = (
    <span style={{ marginRight: 8, verticalAlign: 'middle' }}>
      {typeof swimlane === 'undefined' ? (
        <CircularProgress size={16} style={{ marginLeft: 8 }} />
      ) : swimlane === null ? (
        <span>
          <Tooltip title='Missing board'>
            <ClearIcon style={{ color: 'red' }} />
          </Tooltip>
        </span>
      ) : swimlane === true ? (
        <Tooltip title='Standandard swimlane'>
          <CheckIcon style={{ color: 'green' }} />
        </Tooltip>
      ) : (
        <Tooltip title='Non standandard swimlane'>
          <ClearIcon style={{ color: 'red' }} />
        </Tooltip>
      )}
    </span>
  )

  return (
    <Box>
      {status}
      Board blockers swimlane:{' '}
      <IconButton
        disabled={updating || typeof swimlane === 'undefined'}
        onClick={() => setReloadCounter(reloadCounter + 1)}
        style={{ marginLeft: 8 }}
      >
        <RefreshIcon />
      </IconButton>
      {swimlane === null ? (
        <Tooltip title='Failed to load board swimlanes'>
          <ClearIcon style={{ color: 'red' }} />
        </Tooltip>
      ) : null}
      {typeof swimlane === 'boolean' ? (
        <span>
          {swimlane === true ? 'exists' : 'missing'}{' '}
          {swimlane === true ? null : (
            <Button
              variant='text'
              color='primary'
              disabled={updateClicked}
              onClick={() => onUpdate()}
            >
              Update
              {updating ? (
                <CircularProgress size={16} style={{ marginLeft: 8 }} />
              ) : null}
            </Button>
          )}
        </span>
      ) : null}
    </Box>
  )
}
